<template>
    <div
        class="modal fade text-left"
        id="client-business-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel33"
        aria-hidden="true"
        >
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                <h4 class="modal-title" id="client-modal-title">Import Clients</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="closeModel">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
                <form>
                    <div class="modal-body">
                        <div class="row">
                        <div class="col-md-12 mt-1">
                            <div class="group-area">
                            <p>
                            <!-- get link to csv file -->
                            <strong>Note:</strong> <a href="/storage/sample-client-import.csv"> click here </a> to download a sample client import file
                            </p>
                            </div>
                        </div>
                        <div class="col-md-12 mt-1 mb-1">
                            <div class="form-group">
                                <div class="custom-file">
                                    <input type="file" class="custom-file-input" id="client_sheet" name="client_sheet" @change="selectCSV" ref="fileInput"/>
                                    <label class="custom-file-label" for="customFile">Choose file</label>
                                </div>
                            </div>
                            <span v-if="filename" style="height: 20px;width: auto;background: #00cfe8;padding: 10px;color: white;border-radius: 2px;">{{ filename }}</span>
                        </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-block btn-primary" @click="uploadCSV">Import Clients Now </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import {ref} from 'vue'
export default{
    name : 'ImportClientModal',
    setup(){
        const files = ref(null),
        closeModel = ref(),
        filename = ref(),
        fileInput = ref();
        return{
            files,closeModel,filename,fileInput
        }
    },
    mounted() {
    },
    methods : {
        uploadCSV(){
            let $this = this;
            const formdata = new FormData();
            formdata.append('client_sheet', this.files);
            const route = this.$router.resolve({name:'import-client'}).href;
            if(this.files != null && this.files.type != "text/csv"){
                toastr.error('Please select a csv file','  Client Import Error');
                return;
            }
            if(this.files != null){
                axios.post(route,formdata).then(({data})=>{
                    if(data.error != true){
                        formdata.delete('client_sheet');
                        $this.$emit('refreshed','/get/list/client?page=1')
                        this.$refs.fileInput.value = ''
                        toastr.info(data.message,'  Client Import');
                        $this.closeModel.click();
                        $this.files = null;
                        $this.filename = null;
                        return;
                    }else if(data.error = true){
                        toastr.error(data.message,'  Client Import Error');
                    }else{
                        toastr.error('Something went wrong, please refresh the page and try again.','  Client Import Error');
                    }
                });
            }else{
                toastr.error('Please select a csv file','  Client Import Error');
            }
        },
        selectCSV(e){
            this.files = e.target.files[0];
            this.filename = this.files.name
        }
    }
}
</script>
